module.exports = __webpack_public_path__ + "Icon_Expenses Types.596c16101d360e0d5088.png";